const k = require("./keys");

module.exports = {
  [k.VALMEEGO_COM_THE_HOME_OF_TRI]: `Valmeego.com - The Home of Trip Planners`,
  [k.USER_DETAILS]: `User Details`,
  [k.ID]: `ID:`,
  [k.NAME]: `Name:`,
  [k.EMAIL]: `Email:`,
  [k.EMAIL_VERIFIED_AT]: `Email Verified at:`,
  [k.CREATED_AT]: `Created at:`,
  [k.UPDATED_AT]: `Updated at:`,
  [k.DISABLED]: `Disabled:`,
  [k.BACK_TO_USER_LIST]: `Back to User List`,
  [k._]: `.`,
  [k.MESSAGE_AMEEGO]: `Send a message to `,
  [k.REP_OF_IRELAND]: `Rep. of Ireland`,
  [k.LANGUAGES]: `Languages:`,
  [k.QUALIFICATIONS]: `Qualifications:`,
  [k.QUALIFICATIONS_GO_HERE]: `Qualifications go here.`,
  [k.RATINGS]: `Ratings`,
  [k.ENTER_A_NEW_PASSWORD]: `Enter a new Password`,
  [k.RETYPE_PASSWORD]: `Retype Password`,
  [k.VERIFICATION_CODE_SENT_TO]: `Your code was sent to:`,
  [k.ENTER_CODE]: `Enter Code`,
  [k.SIGNING_YOU_IN_TAKING_TOO_LON]: `Signing you in. Taking too long?`,
  [k.LOGIN]: `Login`,
  [k.SERVICE]: `Service`,
  [k._1]: `#`,
  [k.AMOUNT]: `Amount`,
  [k._2]: `€`,
  [k.DATE]: `Date`,
  [k._3]: `-`,
  [k.MESSAGE]: `Message`,
  [k.VALMEEGO_IS_A_PLATFORM_FOR_TRI]: `Valmeego is a platform for Trip Planners who independently
              organise trips for themselves and groups of family, friends,
              clubmates or colleagues.`,
  [k.VALMEEGO_COMBINES_LOCAL_EXPERT]: `Valmeego combines local experts, direct bookings and a set of
              organisational tools to take the pain out of researching, planning
              and booking any trip.`,
  [k.PERSONAL_RECOMMENDATIONS_FROM]: `Personal recommendations from locally connected experts and direct
              booking ensure best value and customised service.`,
  [k.XS]: `xs`,
  [k.ENTER_YOUR_ACCESS_CODE]: `Enter your Access Code`,
  [k.OFF]: `off`,
  [k.CODE]: `code`,
  [k.ENTER]: `Enter`,
  [k._4]: `_ _ _ _`,
  [k.WRONG_PASSWORD_PLEASE_TRY_AGA]: `Wrong password, please try again`,
  [k.SUBMIT]: `submit`,
  [k.CODE_SUBMIT]: `code-submit`,
  [k.GERARD_BUTTERLY]: `Gerard Butterly`,
  [k.GERARD_BUTTERLY_VALMEEGO_COM]: `gerard.butterly@valmeego.com`,
  [k.GET_IN_TOUCH]: `Get in Touch`,
  [k.ADDED]: `Added:`,
  [k.BE_FIRST_IN_LINE]: `Be first In line`,
  [k._5]: `99+`,
  [k.LATEST_VERSION]: `Latest Version:`,
  [k.KEEP_ME_UP_TO_DATE]: `Keep me up to date`,
  [k.DON_T_WORRY_WE_WON_T_SEND_YOU]: `Don't worry we won't send you spam or share your email address.`,
  [k.CREATE_QUOTE]: `Create Quote -`,
  [k.INTERNAL_REFERENCE]: `Internal Reference #`,
  [k.PRICE]: `Price *`,
  [k.DESCRIPTION]: `Description *`,
  [k.RATE_THIS_SERVICE]: `Rate this Service`,
  [k.RATING]: `Rating:`,
  [k.DESCRIBE_YOUR_EXPERIENCE]: `Describe your experience:`,
  [k.THERE_IS_NO_TRIP_ASSOCIATED_WI]: `There is no trip associated with this message, if you need this
                service to provide you with quotes / booking please go through
                the trip chat.`,
  [k.ADMIN_MENU]: `Admin Menu`,
  [k.DASHBOARD]: `Dashboard`,
  [k.TRIPS]: `Trips`,
  [k.USERS]: `Users`,
  [k.SERVICE_PROVIDERS]: `Service Providers`,
  [k.DMO]: `DMO`,
  [k.PRO_PLANNERS]: `Pro Planners`,
  [k.TRIP_PLANNERS]: `Trip Planners`,
  [k.NEWSLETTER]: `Newsletter`,
  [k.INVITE]: `Invite`,
  [k.EXAMPLE_TELEPHONE]: `For example: +353 86 123 4567`,
  [k.RATE_YOUR_AMEEGO]: `Rate your Ameego`,
  [k.DRAG_AND_DROP_FILES_FOR_UPLOAD]: `Drag and drop files for upload`,
  [k.OR]: `or`,
  [k.COMPATIBLE_FORMATS]: `Compatible formats:`,
  [k._6]: `,`,
  [k.UH_OH]: `Uh, oh!`,
  [k.THERE_S_NOTHING_HERE]: `There's nothing here.`,
  [k.ERROR]: `404 Error`,
  [k.UH_OH_THERE_S_NOTHING_HERE]: `Uh oh, there's nothing here.`,
  [k.RETURN_TO_HOME]: `Return to Home`,
  [k.INVITATIONS]: `Invitations`,
  [k.EDIT_AMEEGO_PROFILE]: `Edit Ameego Profile`,
  [k.PARTICIPANT]: `participant`,
  [k.S]: `s`,
  [k.REJECT]: `Reject`,
  [k.APPLICATION_JSON]: `application/json`,
  [k.FAILED_TO_LOAD]: `failed to load`,
  [k.DMO_DETAILS]: `DMO Details`,
  [k.URL]: `URL:`,
  [k.AREA]: `Area:`,
  [k.DESCRIPTION1]: `Description:`,
  [k.BACK_TO_SERVICE_PROVIDER_LIST]: `Back to Service Provider List`,
  [k.USERS_CONNECTED]: `Users connected:`,
  [k.USERS_REGISTERED]: `Users Registered:`,
  [k.DAU]: `DAU:`,
  [k.TRIP_FINANCES]: `Trip Finances`,
  [k.DAU_VS_TOTAL_REGISTERED]: `DAU vs Total registered:`,
  [k.MESSAGES]: `Messages:`,
  [k.GROWTH_RATE_MESSAGES_DAY]: `Growth Rate Messages / Day:`,
  [k.CREATED_TRIPS]: `Created Trips:`,
  [k.GROWTH_RATE_TRIPS_DAY]: `Growth Rate Trips / Day:`,
  [k.TRIP_PLANNERS1]: `Trip Planners:`,
  [k.GROWTH_RATE_PLANNERS_DAY]: `Growth Rate Planners / Day:`,
  [k.AMEEGOS]: `Ameegos:`,
  [k.GROWTH_RATE_AMEEGOS_DAY]: `Growth Rate Ameegos / Day:`,
  [k.SERVICE_PROVIDERS1]: `Service Providers:`,
  [k.GROWTH_RATE_SERVICE_PROVIDERS]: `Growth Rate Service Providers / Day:`,
  [k.INVITES_VS_TRIPS_CREATED]: `Invites vs Trips Created:`,
  [k.TRIPS_WITH_AMEEGOS]: `Trips with Ameegos:`,
  [k.TRIPS_WITH_BOOKINGS]: `Trips with Bookings:`,
  [k.GROWTH_RATE_TRIPS_BOOKINGS]: `Growth Rate Trips Bookings:`,
  [k.VALUE_BOOKINGS_MEAN]: `Value Bookings Mean:`,
  [k.VALUE_BOOKINGS_MEDIAN]: `Value Bookings median:`,
  [k.INVITE_USERS]: `Invite Users`,
  [k.NAME1]: `name`,
  [k.USER_TYPE]: `User Type`,
  [k.LANGSELECT]: `langSelect`,
  [k.LANGS]: `langs`,
  [k.TYPESELECT]: `typeSelect`,
  [k.LALA]: `lala`,
  [k.SUCCESS]: `success`,
  [k.SUCCESS1]: `Success!`,
  [k.INVITE_HAS_BEEN_SENT]: `Invite has been sent!`,
  [k.TRIP_PLANNER]: `Trip Planner`,
  [k.AMEEGO]: `Ameego`,
  [k.SERVICE_PROVIDER]: `Service Provider`,
  [k.PRO_TRIP_PLANNER]: `Pro Trip Planner`,
  [k.BUSINESS_NAME]: `Business Name:`,
  [k.INTEREST_LOCAL_ADVISOR]: `Interest Local advisor:`,
  [k.INTEREST_TRAVEL_BUSINESS]: `Interest Travel Business:`,
  [k.SERVICE_PROVIDER_DETAILS]: `Service Provider Details`,
  [k.PHONE]: `Phone:`,
  [k.CONTENT_GOES_HERE]: `Content goes here`,
  [k.KEY_PROBLEMS]: `Key Problems:`,
  [k.WISH_LIST]: `Wish list:`,
  [k.BACK_TO_TRIP_PLANNER_LIST]: `Back to Trip planner List`,
  [k.ERROR1]: `Error...`,
  [k.WHAT_ARE_AMEEGOS]: `What Are Ameegos?`,
  [k.AMEEGOS_ARE_EXPERT_LOCAL_AND_T]: `Ameegos are expert local and travel advisors.`,
  [k.AMEEGOS_PROVIDE_EXPERT_LOCAL_A]: `Ameegos provide expert local advise, guidance and recommendations to
            trip planners and travel groups who engage them.`,
  [k.ENGAGING_AN_AMEEGO_SAVES_TIME]: `Engaging an Ameego saves time, effort, money and wasted
            opportunities.`,
  [k.CHOOSE_THE_MOST_RELEVANT_AMEEG]: `Choose the most relevant Ameego by location, language, expertise and
            knowledge.`,
  [k.AMEEGOS_WORK_SOLELY_FOR_THOSE]: `Ameegos work solely for those who engage them from the planning
            phase through to the end of the trip.`,
  [k.AMEEGOS_CANNOT_SEE_YOUR_GROUP]: `Ameegos cannot see your group chat and can only chat directly to the
            Trip Admin or answer other queries indirectly through the trip Q&A
            forum.`,
  [k.API_FILE]: `/api/file`,
  [k.API_FILE1]: `/api/file/`,
  [k.POST]: `POST`,
  [k.MY_TRIPS]: `My Trips`,
  [k.WELCOME_COMPONENT_TO_GO_HERE]: `Welcome component to go here`,
  [k.NIGHT]: `1 Night`,
  [k.NIGHTS]: `Nights`,
  [k.GOING]: `going.`,
  [k._7]: `100%`,
  [k.MY_PHOTOS]: `My Photos`,
  [k.REM]: `2rem`,
  [k.SERVICES]: `Services`,
  [k.MY_NOTIFICATIONS]: `My Notifications`,
  [k.BUTTON_CHOOSE_AMEEGO]: `button-choose-ameego`,
  [k.CHOOSE]: `Choose`,
  [k.FOR_YOUR_TRIP]: `for your trip`,
  [k.ERROR2]: `error`,
  [k.YOU_HAVE_INVITED]: `You have invited`,
  [k.PARTICIPANTS]: `Participants`,
  [k.INVITE_SOMEONE_NEW]: `Invite someone new`,
  [k.NAME2]: `Name`,
  [k.SURNAME]: `Surname`,
  [k.PHONE1]: `Phone`,
  [k.SEND_INVITE]: `Send Invite!`,
  [k.INVITED]: `Invited`,
  [k.REJECTED]: `Rejected`,
  [k.APP_TRIP]: `/app/trip/`,
  [k.PARTICIPANTS1]: `/participants`,
  [k.VIEW_ITINERARY]: `View Itinerary`,
  [k.TRIP_CHAT]: `Trip Chat`,
  [k.ADD_AN_AMEEGO]: `Add an Ameego`,
  [k.WHAT_IS_AN_AMEEGO]: `What is an Ameego?`,
  [k.AMEEGO_CHAT]: `Ameego Chat`,
  [k.RATE_YOUR_AMEEGO1]: `Rate your ameego`,
  [k.VIEW_SERVICES_NEAR]: `View Services near`,
  [k.TRIP_AMEEGO]: `Trip Ameego`,
  [k.LEAVE_THIS_TRIP]: `Leave this trip?`,
  [k.BACKGROUND_IMAGE]: `Background Image`,
  [k.API_IMAGE]: `/api/image`,
  [k.ENTER_A_SECURE_PASSWORD_TO_PRO]: `Enter a secure password to protect your Account`,
  [k.YOUR_PASSWORD_SHOULD]: `Your password should:`,
  [k.BE_AT_LEAST_X_CHARACTERS_LONG]: `Be at least X characters long`,
  [k.ETC]: `Etc..`,
  [k.BACK_TO_LOGIN]: `Back to Login`,
  [k.TROUBLE_LOGGING_IN]: `Trouble Logging In?`,
  [k.ENTER_YOUR_EMAIL_ADDRESS]: `Enter your Email Address`,
  [k.YOU_HAVE_BEEN_SUBSCRIBED]: `You have been subscribed!`,
  [k.ENTER_YOUR_EMAIL_ADDRESS_BELOW]: `Enter your email address below and be first in line for our
                latest news.`,
  [k.NEWSLETTER1]: `newsletter`,
  [k.PLEASE_ENTER_A_VALID_EMAIL_ADD]: `Please enter a valid email address that is not already
                      registered.`,
  [k.EMAIL1]: `email`,
  [k.NEWSLETTER_EMAIL]: `newsletter-email`,
  [k.ENTER_YOUR_EMAIL_ADDRESS1]: `Enter Your Email Address...`,
  [k.WE_DON_T_SPAM_OR_SHARE_YOUR_AD]: `We don’t spam or share your address with third parties.`,
  [k.NEWSLETTER_SUBSCRIBE]: `newsletter-subscribe`,
  [k.HI]: `Hi`,
  [k.WELCOME_TO]: `, welcome to`,
  [k.HAS_INVITED_YOU_TO]: `has invited you to
                join their trip!`,
  [k.VERIFY_NUMBER]: `Verify Your Number`,
  [k.WE_WILL_SEND_YOU_AN_SMS_CODE_T]: `We will send you an SMS code to verify`,
  [k.SEND_ME_CODE]: `Send code to`,
  [k.EMAIL2]: `Email`,
  [k.ENTER_SMS_CODE]: `Enter SMS Code`,
  [k.NAME3]: `Name *`,
  [k.SURNAME1]: `Surname *`,
  [k.PHONE2]: `Phone *`,
  [k.EMAIL3]: `Email *`,
  [k.WHAT_AREA_DOES_YOUR_DMO_PROMOT]: `What area does your DMO promote? *`,
  [k.WHAT_ARE_YOUR_KEY_PROBLEMS_IN]: `What are your key problems in promoting your area?`,
  [k.SUBMIT1]: `Submit`,
  [k.YOU_HAVE_BEEN_REGISTERED]: `You have been registered`,
  [k.WELCOME_TO1]: `Welcome to`,
  [k.PLEASE_ENTER_YOUR_DETAILS]: `Please enter your details`,
  [k.BUSINESS_NAME1]: `Business Name *`,
  [k.WEBSITE]: `Website:`,
  [k.SERVICE_OR_PRODUCT_DESCRIPTION]: `Service or Product Description:`,
  [k.FIRST_NAME]: `First Name *`,
  [k.YOUR_KEY_PROBLEMS_WHEN_ORGANIS]: `What are your key problems when organising a trip?`,
  [k.YOUR_TOP_WISH_LIST_COUNTRIE]: `What are your top 10 Wish List Countries?`,
  [k.FAMILY_NAME]: `Family Name*`,
  [k.WEBSITE1]: `Website`,
  [k.PLEASE_CHECK_ALL_THAT_APPLY]: `Please Check All That Apply`,
  [k.I_AM_INTERESTED_IN_VALMEEGO_FO]: `I am interested in Valmeego for my existing Travel
                      Business`,
  [k.I_AM_INTERESTED_IN_VALMEEGO_AS]: `I am interested in Valmeego as an Expert Local Advisor`,
  [k.PAGES_IN_STORYBOOK]: `Pages in Storybook`,
  [k.WE_RECOMMEND_BUILDING_UIS_WITH]: `We recommend building UIs with a`,
  [k.COMPONENT_DRIVEN]: `component-driven`,
  [k.PROCESS_STARTING_WITH_ATOMIC_C]: `process starting with atomic components and ending with pages.`,
  [k.RENDER_PAGES_WITH_MOCK_DATA_T]: `Render pages with mock data. This makes it easy to build and review page states without
        needing to navigate to them in your app. Here are some handy patterns for managing page data
        in Storybook:`,
  [k.USE_A_HIGHER_LEVEL_CONNECTED_C]: `Use a higher-level connected component. Storybook helps you compose such data from the
          "args" of child component stories`,
  [k.ASSEMBLE_DATA_IN_THE_PAGE_COMP]: `Assemble data in the page component from your services. You can mock these services out
          using Storybook.`,
  [k.GET_A_GUIDED_TUTORIAL_ON_COMPO]: `Get a guided tutorial on component-driven development at`,
  [k.STORYBOOK_TUTORIALS]: `Storybook tutorials`,
  [k.READ_MORE_IN_THE]: `. Read more in the`,
  [k.DOCS]: `docs`,
  [k.TIP]: `Tip`,
  [k.ADJUST_THE_WIDTH_OF_THE_CANVAS]: `Adjust the width of the canvas with the`,
  [k.VIEWPORTS_ADDON_IN_THE_TOOLBAR]: `Viewports addon in the toolbar`,
  [k.PEOPLE_HAVE_BEEN_INVITED]: `people have been invited.`,
  [k.OFFLINE]: `Offline`,
  [k.OFFLINE_DESCRIPTION]: `Please try again when you have an internet connection`,
  [k.GO_BACK]: `Go Back`,
  [k.AMEEGO_IS_VERIFIED]: `This Ameego has verified their identity`,
  [k.AMEEGO_NOT_VERIFIED]: `This Ameego has not verified their identity`,
  [k.SEND_AN_INVITE]: `Send an Invite`,
  [k.VIEW_BOOKINGS]: `View Bookings`,
  [k.AMEEGO_INVITE_EXPLANATION]: `You can select up to 3 Ameegos. Only one can accept your invite.`,
  [k.COOKIE_BANNER]: `This website uses cookies to enhance the user experience.`,
  [k.COOKIE_ACCEPT]: `I understand`,
  [k.SETTINGS]: `Settings`,
  [k.SPEAKS]: `Speaks`,
  [k.ITINERARY_TITLE_AND_DETAILS]: "Title and Details",
  [k.HAS_INVITED_YOU_TO_HAVE_A_LOOK]: `Has invited you to have a look at the trip before deciding`,
  [k.UPCOMING_TRIP_BOOKINGS]: "Upcoming bookings for this trip",
};
